
import PropTypes from 'prop-types'
import React from 'react'

const Close = props => {
  const divStyle = {
    width: 12,
    height: 13
  }

  const svgStyle = {
    verticalAlign: 'top'
  }

  return (
    <div style={divStyle} className={props.class} {...props}>
      <svg style={svgStyle} width='12' height='13' viewBox='912 13 12 13' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round' stroke='#B7BDC4' strokeWidth='1.5'>
          <path d='M913 14.377l10.083 10.083M923.083 14.377L913 24.46' />
        </g>
      </svg>
    </div>
  )
}

Close.propTypes = {
  class: PropTypes.string
}

Close.displayName = 'Close'

export default Close



// WEBPACK FOOTER //
// ./ui/icons/close.js